import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { IconButton } from "@/components/flowly/infra/IconButton/IconButton";

interface LightboxNavigationProps {
  currentIndex: number;
  totalItems: number;
  canGoNext: boolean;
  canGoPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
}

export function LightboxNavigation({
  currentIndex,
  totalItems,
  canGoNext,
  canGoPrev,
  onNext,
  onPrev,
}: LightboxNavigationProps) {
  if (totalItems <= 1) return null;

  return (
    <>
      {/* Previous Arrow */}
      <IconButton
        variant="overlay"
        size="lg"
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        disabled={!canGoPrev}
        className={cn(
          "absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-20",
          "w-10 h-10 md:w-12 md:h-12",
          !canGoPrev && "opacity-30 cursor-not-allowed"
        )}
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </IconButton>

      {/* Next Arrow */}
      <IconButton
        variant="overlay"
        size="lg"
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        disabled={!canGoNext}
        className={cn(
          "absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-20",
          "w-10 h-10 md:w-12 md:h-12",
          !canGoNext && "opacity-30 cursor-not-allowed"
        )}
      >
        <ChevronRight className="w-6 h-6 text-white" />
      </IconButton>

      {/* Position Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 px-4 py-2 bg-black/70 rounded-full" dir="ltr">
        <span className="text-white text-sm font-bold">
          {currentIndex + 1} / {totalItems}
        </span>
      </div>
    </>
  );
}
